var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"e3c5f4c0b9e3748187168c315bcccf254a2f2cfa"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["docupet-app-store@docupet"]={id:"e3c5f4c0b9e3748187168c315bcccf254a2f2cfa"};
      